import EsimResource from 'flow/api/esim';
import Actions from 'flow/actions';
import { httpGetErrorDispatcher } from 'flow/actions/app-actions';

export const orderEsim = (extensionKey) => (dispatch) => {
    return new Promise((resolve, reject) => {
        EsimResource.orderEsim({
            onResult(result) {
                dispatch(receiveNewPendingEsim(result, extensionKey));
                resolve();
            },
            onError: (error) => {
                httpGetErrorDispatcher(dispatch)(error);
                reject(error);
            },
            onClientError: (error) => {
                reject(error);
            },
        });
    });
};

const receiveNewPendingEsim = (data, extensionKey) => ({
    type: Actions.RESULT_NEW_PENDING_ESIM,
    extensionKey: extensionKey,
    data: data,
});
